import useBenguide from 'hooks/benguide';
import { useAppDispatch } from 'hooks/redux';
import {
  fetchTelehealthPlanList,
  reloadTelehealthSection,
} from 'modules/benefitsWellness/slices/telehealthSlice';
import UPClient from 'modules/clients/UPClient/UPClient';
import useUPClient from 'modules/clients/UPClient/useUPClient';

import {
  TELEHEALTH_PLAN_CHANNEL,
  BENGUIDE_NOTIFICATION_HIDE_OVERLAY,
  BENGUIDE_NOTIFICATION_SHOW_OVERLAY,
  BENGUIDE_NOTIFICATIONS,
  RELOAD_TELEHEALTH_PLAN_LIST,
  RELOAD_TELEHEALTH_PLAN,
} from 'modules/clients/UPClient/UPClientConst';

const TelehealthPlansChannel = () => {
  const dispatch = useAppDispatch();
  const benguide = useBenguide();
  const upClient = useUPClient();
  return (
    <UPClient
      channel={TELEHEALTH_PLAN_CHANNEL}
      subscribe={(event: string) => {
        switch (event) {
          case RELOAD_TELEHEALTH_PLAN_LIST:
            dispatch(
              fetchTelehealthPlanList(
                benguide.employerId,
                benguide.planYearId,
                benguide.benefitClasses
              )
            );
            break;
          case RELOAD_TELEHEALTH_PLAN:
            dispatch(
              reloadTelehealthSection(
                benguide.masterId,
                benguide.latestRevision
              )
            );
            dispatch(
              fetchTelehealthPlanList(
                benguide.employerId,
                benguide.planYearId,
                benguide.benefitClasses
              )
            );
            break;
          case BENGUIDE_NOTIFICATION_HIDE_OVERLAY:
            upClient.postMessage({
              channel: BENGUIDE_NOTIFICATIONS,
              event: BENGUIDE_NOTIFICATION_HIDE_OVERLAY,
              data: {},
            });
            break;
          case BENGUIDE_NOTIFICATION_SHOW_OVERLAY:
            upClient.postMessage({
              channel: BENGUIDE_NOTIFICATIONS,
              event: BENGUIDE_NOTIFICATION_SHOW_OVERLAY,
              data: {},
            });
            break;
        }
      }}
    />
  );
};

export default TelehealthPlansChannel;
